<template>
  <v-container fluid class="pt-4 guiones-rev">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="9">
        <v-card class="shadowCard pa-4">
          <div class="d-flex align-center flex-wrap mb-2">
            <div>
              <div class="text-h6 font-weight-bold" style="color:#006093">
                Revisión Agente IA
              </div>
              <div class="text-caption grey--text">
                Solo puestos COMERCIAL · Guiones, dudas y conversaciones de alumnos
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              v-if="pestana === 'guiones'"
              color="#006093"
              dark
              class="text-capitalize"
              :loading="generando"
              @click="abrirGenerar"
            >
              <v-icon left small>mdi-auto-fix</v-icon>
              Generar borradores
            </v-btn>
          </div>

          <v-tabs v-model="pestana" color="#006093" class="mb-3">
            <v-tab href="#guiones">Guiones</v-tab>
            <v-tab href="#dudas">Dudas / aclaraciones</v-tab>
            <v-tab href="#conversaciones">Conversaciones</v-tab>
          </v-tabs>

          <v-tabs-items v-model="pestana">
            <v-tab-item value="guiones">
              <v-row dense class="mb-3">
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="filtroStatus"
                    :items="statusOptions"
                    label="Estatus"
                    dense
                    outlined
                    hide-details
                    clearable
                    @change="cargarLista"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="filtroNivel"
                    label="Nivel"
                    dense
                    outlined
                    hide-details
                    clearable
                    @keyup.enter="cargarLista"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="filtroLeccion"
                    label="Lección"
                    dense
                    outlined
                    hide-details
                    clearable
                    @keyup.enter="cargarLista"
                  />
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                  <v-btn text color="#006093" class="text-capitalize" :loading="loading" @click="cargarLista">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Sin guiones"
              >
                <template v-slot:item.status="{ item }">
                  <v-chip x-small :color="colorStatus(item.status)" dark>{{ item.status }}</v-chip>
                </template>
                <template v-slot:item.tema="{ item }">
                  {{ item.tema || (item.contenido && item.contenido.tema) || '—' }}
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn icon small color="#c62828" title="Rechazar" :disabled="item.status === 'rechazado'" @click="confirmarRechazo(item)">
                    <v-icon small>mdi-close-circle</v-icon>
                  </v-btn>
                  <v-btn icon small color="#2e7d32" title="Aprobar" :disabled="item.status === 'publicado' || item.status === 'rechazado'" @click="aprobar(item)">
                    <v-icon small>mdi-check-circle</v-icon>
                  </v-btn>
                  <v-btn icon small color="#006093" title="Editar" @click="abrirEditar(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>

            <v-tab-item value="dudas">
              <div class="text-caption grey--text mb-2">
                Incluye respuestas generadas en vivo (origen ia_vivo) en borrador para reutilizarlas.
              </div>
              <v-row dense class="mb-3">
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="filtroStatusDudas"
                    :items="statusOptions"
                    label="Estatus"
                    dense
                    outlined
                    hide-details
                    clearable
                    @change="cargarDudas"
                  />
                </v-col>
                <v-col cols="12" sm="8" class="d-flex align-center">
                  <v-btn text color="#006093" class="text-capitalize" :loading="loadingDudas" @click="cargarDudas">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headersDudas"
                :items="itemsDudas"
                :loading="loadingDudas"
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Sin dudas"
              >
                <template v-slot:item.status="{ item }">
                  <v-chip x-small :color="colorStatus(item.status)" dark>{{ item.status }}</v-chip>
                </template>
                <template v-slot:item.origen="{ item }">
                  <v-chip x-small outlined>{{ item.origen }}</v-chip>
                </template>
                <template v-slot:item.pregunta_o_duda="{ item }">
                  <span class="text-truncate d-inline-block" style="max-width:220px">{{ item.pregunta_o_duda }}</span>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn icon small color="#c62828" title="Rechazar" :disabled="item.status === 'rechazado'" @click="rechazarDudaItem(item)">
                    <v-icon small>mdi-close-circle</v-icon>
                  </v-btn>
                  <v-btn icon small color="#2e7d32" title="Aprobar" :disabled="item.status === 'publicado' || item.status === 'rechazado'" @click="aprobarDudaItem(item)">
                    <v-icon small>mdi-check-circle</v-icon>
                  </v-btn>
                  <v-btn icon small color="#006093" title="Editar" @click="abrirEditarDuda(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>

            <v-tab-item value="conversaciones">
              <div class="text-caption grey--text mb-2">
                Prácticas reales hechas por alumnos en la app. Abre una para revisar el chat y su evaluación.
              </div>
              <v-row dense class="mb-3">
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="filtroRevision"
                    :items="revisionOptions"
                    label="Revisión"
                    dense
                    outlined
                    hide-details
                    clearable
                    @change="cargarConversaciones"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="filtroEstadoConversacion"
                    :items="estadoConversacionOptions"
                    label="Práctica"
                    dense
                    outlined
                    hide-details
                    clearable
                    @change="cargarConversaciones"
                  />
                </v-col>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="filtroMatricula"
                    label="Matrícula"
                    dense
                    outlined
                    hide-details
                    clearable
                    @keyup.enter="cargarConversaciones"
                  />
                </v-col>
                <v-col cols="12" sm="3" class="d-flex align-center">
                  <v-btn text color="#006093" class="text-capitalize" :loading="loadingConversaciones" @click="cargarConversaciones">
                    <v-icon left small>mdi-refresh</v-icon>
                    Actualizar
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headersConversaciones"
                :items="itemsConversaciones"
                :loading="loadingConversaciones"
                :items-per-page="10"
                class="elevation-0"
                no-data-text="Sin conversaciones"
              >
                <template v-slot:item.alumno="{ item }">
                  <div>{{ item.alumno_nombre || `Alumno #${item.alumno_id}` }}</div>
                  <div class="text-caption grey--text">
                    Matrícula {{ item.alumno_matricula || '—' }}
                  </div>
                </template>
                <template v-slot:item.leccion="{ item }">
                  Nivel {{ item.nivel }} · {{ item.leccion }}
                </template>
                <template v-slot:item.estado="{ item }">
                  <v-chip x-small :color="item.estado === 'completada' ? 'green' : 'blue'" dark>
                    {{ item.estado }}
                  </v-chip>
                </template>
                <template v-slot:item.revision_estado="{ item }">
                  <v-chip x-small :color="colorRevision(item.revision_estado)" dark>
                    {{ item.revision_estado }}
                  </v-chip>
                </template>
                <template v-slot:item.fecha_inicio="{ item }">
                  {{ formatearFecha(item.fecha_inicio) }}
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-btn icon small color="#006093" title="Revisar conversación" @click="abrirConversacion(item)">
                    <v-icon small>mdi-message-text-outline</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <!-- Generar desde JSON Teacher -->
    <v-dialog v-model="dialogGenerar" max-width="720" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Generar borradores</v-card-title>
        <v-card-text>
          <div class="text-body-2 mb-2">
            Pega el JSON del Teacher (<code>lessons</code> o una lección suelta).
            Se crea <strong>1 borrador por lección</strong> con vocabulario y summary.
          </div>
          <v-textarea
            v-model="formGen.lessonsJson"
            label="JSON lección (Teacher)"
            outlined
            dense
            rows="14"
            hide-details="auto"
            :error-messages="formGen.jsonError ? [formGen.jsonError] : []"
            class="mono-json"
            placeholder='{ "lessons": [ { "level": 1, "lesson": 6, "topic": "...", "vocabulary": [], "summary": "..." } ] }'
          />
          <div class="text-caption grey--text mt-2">
            Campos requeridos por lección: level, lesson, topic, vocabulary[], summary.
            Después puedes editar en el formulario o en Vista técnica (JSON).
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize" @click="dialogGenerar = false">Cancelar</v-btn>
          <v-btn color="#006093" dark class="text-capitalize" :loading="generando" @click="generar">Generar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Editor formulario -->
    <v-dialog v-model="dialogEditar" max-width="820" persistent scrollable>
      <v-card class="guiones-edit-card">
        <v-card-title class="text-subtitle-1 guiones-edit-card__title">
          <div class="guiones-edit-card__title-text">
            Editar lección {{ editForm.nivel }}-{{ editForm.leccion }}
            <span v-if="editForm.tema"> — {{ editForm.tema }}</span>
          </div>
        </v-card-title>
        <v-card-text class="guiones-edit-card__body">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="editForm.tema" label="Topic / título de la lección" outlined dense />
            </v-col>
            <v-col cols="4" sm="2">
              <v-text-field v-model="editForm.nivel" label="Nivel" outlined dense disabled />
            </v-col>
            <v-col cols="4" sm="2">
              <v-text-field v-model="editForm.leccion" label="Lección" outlined dense disabled />
            </v-col>
            <v-col cols="4" sm="2">
              <v-text-field
                v-model.number="editForm.orden"
                type="number"
                min="1"
                label="Orden"
                outlined
                dense
                hint="Posición en la lista"
                persistent-hint
              />
            </v-col>
          </v-row>
          <v-textarea
            v-model="editForm.explicacion"
            label="Summary / foco de la lección"
            outlined
            dense
            rows="5"
            auto-grow
            class="mt-3"
            hint="Texto completo del Teacher (debe verse desde el inicio)"
            persistent-hint
          />
          <v-textarea
            v-model="editForm.vocabularioTexto"
            label="Vocabulary (separado por comas)"
            outlined
            dense
            rows="2"
            auto-grow
            class="mt-2"
            hint="Ej. hello, fine, happy"
            persistent-hint
          />
          <div class="text-caption grey--text mt-3 mb-1">
            Duración de la práctica: la elige el <strong>alumno</strong> en la app (4, 8 o 15 intercambios).
            No se configura aquí.
          </div>
          <v-textarea
            v-model="editForm.mensaje_no_sabes"
            label="Mensaje si no entiende (no_sabes)"
            outlined
            dense
            rows="2"
          />
          <v-textarea
            v-model="editForm.mensaje_limite_ia"
            label="Mensaje límite IA vivo"
            outlined
            dense
            rows="2"
          />

          <div class="text-caption grey--text mb-2 mt-3">
            Turnos de respaldo (opcional). Si están vacío, la conversación va por IA en vivo con las reglas.
          </div>
          <div
            v-for="(turno, idx) in editForm.turnosIa"
            :key="'turno-' + idx"
            class="edit-turno pa-3 mb-3"
          >
            <div class="font-weight-bold mb-2" style="color:#006093">
              Turno IA {{ idx + 1 }} (orden {{ turno.orden }})
            </div>
            <v-textarea v-model="turno.texto" label="Texto de la IA" outlined dense rows="2" />
            <v-textarea
              v-model="turno.rama_positiva"
              label="Si responde bien → texto IA"
              outlined
              dense
              rows="2"
            />
            <v-textarea
              v-model="turno.rama_negativa"
              label="Si responde mal → texto IA (reconducir al mismo tema)"
              outlined
              dense
              rows="2"
            />
          </div>

          <v-expansion-panels class="mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header>
                Vista técnica (JSON) — solo soporte
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  v-model="editJson"
                  outlined
                  dense
                  rows="12"
                  :error-messages="editJsonError"
                  @change="aplicarJsonAlForm"
                />
                <v-btn text small color="#006093" class="text-capitalize" @click="refrescarJsonDesdeForm">
                  Refrescar JSON desde formulario
                </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize" @click="dialogEditar = false">Cancelar</v-btn>
          <v-btn color="#006093" dark class="text-capitalize" :loading="guardando" @click="guardarEdicion">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarDuda" max-width="560" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Editar duda #{{ editDuda && editDuda.id }}</v-card-title>
        <v-card-text>
          <v-textarea v-model="editDudaForm.pregunta_o_duda" label="Pregunta / duda del alumno" outlined dense rows="3" />
          <v-textarea v-model="editDudaForm.respuesta" label="Respuesta" outlined dense rows="4" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize" @click="dialogEditarDuda = false">Cancelar</v-btn>
          <v-btn color="#006093" dark class="text-capitalize" :loading="guardando" @click="guardarEdicionDuda">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConversacion" max-width="820" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Conversación #{{ conversacionDetalle && conversacionDetalle.id }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogConversacion = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-subtitle v-if="conversacionDetalle" class="pt-1">
          {{ conversacionDetalle.alumno_nombre || `Alumno #${conversacionDetalle.alumno_id}` }}
          · Matrícula {{ conversacionDetalle.alumno_matricula || '—' }}
          · Nivel {{ conversacionDetalle.nivel }} · {{ conversacionDetalle.leccion }}
          · {{ conversacionDetalle.tema || 'Sin tema' }}
        </v-card-subtitle>
        <v-card-text>
          <v-skeleton-loader v-if="loadingDetalle" type="list-item-three-line@3" />
          <div v-else class="revision-chat">
            <div
              v-for="mensaje in mensajesConversacion"
              :key="mensaje.id"
              class="revision-chat__fila"
              :class="{ 'revision-chat__fila--alumno': mensaje.emisor === 'alumno' }"
            >
              <div class="revision-chat__burbuja">
                <div class="text-caption font-weight-bold mb-1">
                  {{ mensaje.emisor === 'alumno' ? 'Alumno' : 'IA' }}
                </div>
                <div>{{ mensaje.texto }}</div>
                <audio
                  v-if="mensaje.audio_url"
                  class="revision-chat__audio mt-2"
                  controls
                  :src="resolverAudioUrl(mensaje.audio_url)"
                />
                <div v-if="mensaje.evaluacion" class="revision-chat__evaluacion mt-2">
                  <div v-if="mensaje.evaluacion.correccion">
                    <strong>Corrección:</strong> {{ mensaje.evaluacion.correccion }}
                  </div>
                  <div v-for="(ok, index) in (mensaje.evaluacion.oks || [])" :key="index">
                    <strong>Observación:</strong> {{ ok }}
                  </div>
                  <div v-if="mensaje.evaluacion.traduccion_sugerida">
                    <strong>Otra forma de decirlo:</strong> {{ mensaje.evaluacion.traduccion_sugerida }}
                  </div>
                  <div class="text-caption grey--text mt-1">
                    Clasificación interna: {{ mensaje.evaluacion.clasificacion || '—' }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!mensajesConversacion.length" class="text-center grey--text pa-4">
              Sin mensajes guardados.
            </div>
          </div>

          <v-divider class="my-4"></v-divider>
          <v-select
            v-model="revisionForm.revision_estado"
            :items="revisionOptions"
            label="Resultado de revisión"
            outlined
            dense
          />
          <v-textarea
            v-model="revisionForm.revision_comentario"
            label="Comentario interno de comercial"
            outlined
            dense
            rows="3"
            counter="2000"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text class="text-capitalize" @click="dialogConversacion = false">Cerrar</v-btn>
          <v-btn color="#006093" dark class="text-capitalize" :loading="guardandoRevision" @click="guardarRevision">
            Guardar revisión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta :parametros="parametros" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'
import {
  listarGuiones,
  generarGuion,
  editarGuion,
  aprobarGuion,
  rechazarGuion,
  listarDudas,
  editarDuda,
  aprobarDuda,
  rechazarDuda,
  listarConversaciones,
  obtenerConversacion,
  revisarConversacion,
} from '@/services/agenteIaGuionesApi.js'

const PUESTOS_COMERCIAL = [18, 19, 73]
const USUARIOS_PRUEBA_GUIONES_IA = [3108]

function contenidoAForm(item) {
  const c = (item && item.contenido) || {}
  const reglas = c.reglas || {}
  const turnos = Array.isArray(c.turnos) ? c.turnos.slice() : []
  turnos.sort((a, b) => Number(a.orden) - Number(b.orden))
  const turnosIa = turnos
    .filter((t) => t.rol === 'ia')
    .map((t) => ({
      orden: Number(t.orden),
      texto: t.texto || '',
      rama_positiva: (t.ramas && t.ramas.positiva && t.ramas.positiva.texto_ia) || '',
      rama_negativa: (t.ramas && t.ramas.negativa && t.ramas.negativa.texto_ia) || '',
    }))
  const vocab = Array.isArray(reglas.vocabulario)
    ? reglas.vocabulario
    : (Array.isArray(c.vocabulary) ? c.vocabulary : [])
  const duracionesDefault = [
    { id: 'corta', label: 'Corta', turnos: 4 },
    { id: 'media', label: 'Media', turnos: 8 },
    { id: 'larga', label: 'Larga', turnos: 15 },
  ]
  return {
    id: item.id,
    nivel: item.nivel,
    leccion: item.leccion,
    orden: item.orden != null ? Number(item.orden) : 1,
    tema: item.tema || c.tema || reglas.topic || '',
    explicacion: item.explicacion || reglas.foco_es || '',
    vocabularioTexto: vocab.join(', '),
    // La duración la elige el alumno (4/8/15); aquí solo se conserva en el JSON
    duraciones: Array.isArray(c.duraciones) && c.duraciones.length
      ? c.duraciones.slice()
      : duracionesDefault,
    total_intercambios: 15,
    mensaje_no_sabes: c.mensaje_no_sabes || '',
    mensaje_limite_ia: c.mensaje_limite_ia || '',
    temas_permitidos: Array.isArray(c.temas_permitidos) ? c.temas_permitidos.slice() : [],
    reglasExtra: reglas,
    turnosIa,
    turnosOriginales: turnos,
  }
}

function formAContenido(form) {
  const turnosIa = form.turnosIa || []
  const turnos = []
  turnosIa.forEach((t, idx) => {
    const ordenIa = Number(t.orden) || (idx * 2 + 1)
    const siguienteIa = turnosIa[idx + 1]
    const siguienteOrden = siguienteIa
      ? (Number(siguienteIa.orden) || ordenIa + 2)
      : ordenIa + 2
    turnos.push({
      orden: ordenIa,
      rol: 'ia',
      texto: t.texto || '',
      ramas: {
        positiva: {
          texto_ia: t.rama_positiva || '',
          siguiente_orden: siguienteOrden,
          avanzar_guion: true,
        },
        negativa: {
          texto_ia: t.rama_negativa || '',
          avanzar_guion: false,
        },
      },
    })
    turnos.push({
      orden: ordenIa + 1,
      rol: 'alumno',
      texto: '(Student answers)',
    })
  })

  const orig = form.turnosOriginales || []
  turnos.forEach((t) => {
    if (t.rol !== 'alumno') return
    const prev = orig.find((o) => Number(o.orden) === Number(t.orden) && o.rol === 'alumno')
    if (prev && prev.texto) t.texto = prev.texto
  })

  const vocabulario = String(form.vocabularioTexto || '')
    .split(/[,;\n]/)
    .map((s) => s.trim())
    .filter(Boolean)
  const prevReglas = form.reglasExtra || {}
  const duraciones = (form.duraciones && form.duraciones.length)
    ? form.duraciones.slice()
    : [
      { id: 'corta', label: 'Corta', turnos: 4 },
      { id: 'media', label: 'Media', turnos: 8 },
      { id: 'larga', label: 'Larga', turnos: 15 },
    ]

  return {
    tema: form.tema || '',
    reglas: Object.assign({}, prevReglas, {
      topic: form.tema || prevReglas.topic || '',
      vocabulario: vocabulario,
      foco_es: form.explicacion || prevReglas.foco_es || '',
      gramatica: Array.isArray(prevReglas.gramatica) ? prevReglas.gramatica : [],
      nivel_cefr: prevReglas.nivel_cefr || 'A1',
    }),
    temas_permitidos: (form.temas_permitidos && form.temas_permitidos.length)
      ? form.temas_permitidos.slice()
      : ['clase', 'viajes', 'comida', 'deportes', 'videojuegos'],
    duraciones: duraciones,
    total_intercambios: 15,
    mensaje_no_sabes: form.mensaje_no_sabes || '',
    mensaje_limite_ia: form.mensaje_limite_ia || '',
    turnos,
  }
}

export default {
  name: 'GuionesRevision',
  components: { Alerta },
  mixins: [validarErrores],

  data() {
    return {
      pestana: 'guiones',
      loading: false,
      loadingDudas: false,
      loadingConversaciones: false,
      loadingDetalle: false,
      generando: false,
      guardando: false,
      guardandoRevision: false,
      items: [],
      itemsDudas: [],
      itemsConversaciones: [],
      filtroStatus: 'borrador',
      filtroNivel: '',
      filtroLeccion: '',
      filtroStatusDudas: 'borrador',
      filtroRevision: 'pendiente',
      filtroEstadoConversacion: '',
      filtroMatricula: '',
      statusOptions: [
        { text: 'Borrador', value: 'borrador' },
        { text: 'Publicado', value: 'publicado' },
        { text: 'Rechazado', value: 'rechazado' },
      ],
      headers: [
        { text: 'ID', value: 'id', width: 70 },
        { text: 'Nivel', value: 'nivel' },
        { text: 'Lección', value: 'leccion' },
        { text: 'Orden', value: 'orden', width: 80 },
        { text: 'Tema', value: 'tema' },
        { text: 'Status', value: 'status' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      headersDudas: [
        { text: 'ID', value: 'id', width: 60 },
        { text: 'Lección', value: 'leccion_id' },
        { text: 'Pregunta/duda', value: 'pregunta_o_duda' },
        { text: 'Origen', value: 'origen' },
        { text: 'Status', value: 'status' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      revisionOptions: [
        { text: 'Pendiente', value: 'pendiente' },
        { text: 'Correcta', value: 'correcta' },
        { text: 'Incorrecta', value: 'incorrecta' },
      ],
      estadoConversacionOptions: [
        { text: 'En progreso', value: 'en_progreso' },
        { text: 'Completada', value: 'completada' },
      ],
      headersConversaciones: [
        { text: 'ID', value: 'id', width: 60 },
        { text: 'Alumno', value: 'alumno' },
        { text: 'Lección', value: 'leccion' },
        { text: 'Tema', value: 'tema' },
        { text: 'Práctica', value: 'estado' },
        { text: 'Revisión', value: 'revision_estado' },
        { text: 'Mensajes', value: 'total_mensajes', align: 'center' },
        { text: 'Fecha', value: 'fecha_inicio' },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      dialogGenerar: false,
      formGen: {
        lessonsJson: '',
        jsonError: '',
      },
      dialogEditar: false,
      editItem: null,
      editForm: {
        id: null,
        nivel: '',
        leccion: '',
        orden: 1,
        tema: '',
        explicacion: '',
        vocabularioTexto: '',
        duraciones: [
          { id: 'corta', label: 'Corta', turnos: 4 },
          { id: 'media', label: 'Media', turnos: 8 },
          { id: 'larga', label: 'Larga', turnos: 15 },
        ],
        total_intercambios: 15,
        mensaje_no_sabes: '',
        mensaje_limite_ia: '',
        temas_permitidos: [],
        reglasExtra: {},
        turnosIa: [],
        turnosOriginales: [],
      },
      editJson: '',
      editJsonError: '',
      dialogEditarDuda: false,
      editDuda: null,
      editDudaForm: { pregunta_o_duda: '', respuesta: '' },
      dialogConversacion: false,
      conversacionDetalle: null,
      mensajesConversacion: [],
      revisionForm: { revision_estado: 'pendiente', revision_comentario: '' },
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    esComercial() {
      const u = this.getdatosUsuarioERPERP
      if (!u) return false
      const iderp = Number(u.iderp != null ? u.iderp : u.id_usuario)
      if (USUARIOS_PRUEBA_GUIONES_IA.includes(iderp)) return true
      const idPuesto = Number(u.idpuesto != null ? u.idpuesto : u.id_puesto)
      if (PUESTOS_COMERCIAL.includes(idPuesto)) return true
      const nombre = String(u.puesto || u.nombre_puesto || '').toUpperCase()
      return nombre.includes('COMERCIAL')
    },
  },

  watch: {
    pestana(val) {
      if (val === 'dudas') this.cargarDudas()
      else if (val === 'conversaciones') this.cargarConversaciones()
      else this.cargarLista()
    },
  },

  created() {
    if (!this.esComercial) {
      this.$router.replace({ name: 'Home' })
      return
    }
    this.cargarLista()
  },

  methods: {
    colorStatus(status) {
      if (status === 'publicado') return 'green'
      if (status === 'rechazado') return 'red'
      return 'orange'
    },

    colorRevision(status) {
      if (status === 'correcta') return 'green'
      if (status === 'incorrecta') return 'red'
      return 'orange'
    },

    formatearFecha(value) {
      if (!value) return '—'
      const fecha = new Date(String(value).replace(' ', 'T'))
      return Number.isNaN(fecha.getTime()) ? value : fecha.toLocaleString('es-MX')
    },

    resolverAudioUrl(value) {
      if (!value || /^https?:\/\//i.test(value)) return value
      const base = String(process.env.VUE_APP_API_MOVIL_URL || 'http://localhost:3001').replace(/\/$/, '')
      return `${base}/${String(value).replace(/^\//, '')}`
    },

    errorMsg(error) {
      const data = error && error.response && error.response.data
      if (data) {
        if (typeof data === 'string' && data.trim()) return data
        if (data.message) return data.message
        if (data.sqlMessage) return data.sqlMessage
      }
      return (error && error.message) || String(error || 'Error en el servidor')
    },

    sincronizarTemasGen() {},

    abrirGenerar() {
      this.formGen.jsonError = ''
      if (!this.formGen.lessonsJson) {
        this.formGen.lessonsJson = JSON.stringify({
          lessons: [
            {
              level: 1,
              lesson: 6,
              topic: 'Cómo presentarse',
              vocabulary: [
                'fine', 'very', 'sad', 'hello', 'hi',
                "what's up", "it's a pleasure", 'happy', 'excellent', 'good',
              ],
              summary: 'La lección enseña al alumno a presentarse y comenzar una conversación básica en inglés.',
            },
          ],
        }, null, 2)
      }
      this.dialogGenerar = true
    },

    async generar() {
      this.formGen.jsonError = ''
      const raw = String(this.formGen.lessonsJson || '').trim()
      if (!raw) {
        this.formGen.jsonError = 'Pega el JSON del Teacher'
        this.validarError('Pega el JSON del Teacher')
        return
      }
      let parsed
      try {
        parsed = JSON.parse(raw)
      } catch (e) {
        this.formGen.jsonError = 'JSON inválido'
        this.validarError('JSON inválido')
        return
      }
      this.generando = true
      try {
        const payload = Array.isArray(parsed)
          ? { lessons: parsed }
          : (parsed.lessons != null ? { lessons: parsed.lessons } : parsed)
        const res = await generarGuion(payload)
        const data = res && res.data
        const total = (data && data.total)
          || (data && Array.isArray(data.creados) && data.creados.length)
          || 1
        this.dialogGenerar = false
        this.filtroStatus = 'borrador'
        await this.cargarLista()
        this.validarSuccess(
          total === 1 ? 'Borrador generado desde JSON Teacher' : `${total} borradores generados`
        )
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.generando = false
      }
    },

    async cargarLista() {
      this.loading = true
      try {
        const res = await listarGuiones({
          status: this.filtroStatus || undefined,
          nivel: this.filtroNivel || undefined,
          leccion: this.filtroLeccion || undefined,
        })
        this.items = res.data || []
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loading = false
      }
    },

    async cargarDudas() {
      this.loadingDudas = true
      try {
        const res = await listarDudas({ status: this.filtroStatusDudas || undefined })
        this.itemsDudas = res.data || []
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loadingDudas = false
      }
    },

    async cargarConversaciones() {
      this.loadingConversaciones = true
      try {
        const res = await listarConversaciones({
          revision_estado: this.filtroRevision || undefined,
          estado: this.filtroEstadoConversacion || undefined,
          matricula: this.filtroMatricula || undefined,
        })
        this.itemsConversaciones = res.data || []
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loadingConversaciones = false
      }
    },

    async abrirConversacion(item) {
      this.dialogConversacion = true
      this.loadingDetalle = true
      this.conversacionDetalle = item
      this.mensajesConversacion = []
      try {
        const res = await obtenerConversacion(item.id)
        this.conversacionDetalle = res.data.conversacion
        this.mensajesConversacion = res.data.mensajes || []
        this.revisionForm = {
          revision_estado: this.conversacionDetalle.revision_estado || 'pendiente',
          revision_comentario: this.conversacionDetalle.revision_comentario || '',
        }
      } catch (error) {
        this.validarError(this.errorMsg(error))
        this.dialogConversacion = false
      } finally {
        this.loadingDetalle = false
      }
    },

    async guardarRevision() {
      if (!this.conversacionDetalle) return
      this.guardandoRevision = true
      try {
        const res = await revisarConversacion({
          id: this.conversacionDetalle.id,
          revision_estado: this.revisionForm.revision_estado,
          revision_comentario: this.revisionForm.revision_comentario,
        })
        this.conversacionDetalle = res.data
        this.dialogConversacion = false
        await this.cargarConversaciones()
        this.validarSuccess('Revisión guardada')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.guardandoRevision = false
      }
    },

    async aprobar(item) {
      this.loading = true
      try {
        await aprobarGuion(item.id)
        await this.cargarLista()
        this.validarSuccess('Guion publicado')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loading = false
      }
    },

    confirmarRechazo(item) {
      const motivo = window.prompt('Motivo de rechazo (opcional):', '') || ''
      this.rechazar(item, motivo)
    },

    async rechazar(item, motivo) {
      this.loading = true
      try {
        await rechazarGuion(item.id, motivo)
        await this.cargarLista()
        this.validarSuccess('Guion rechazado')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loading = false
      }
    },

    abrirEditar(item) {
      this.editItem = item
      this.editForm = contenidoAForm(item)
      this.editJson = JSON.stringify(item.contenido || {}, null, 2)
      this.editJsonError = ''
      this.dialogEditar = true
    },

    refrescarJsonDesdeForm() {
      this.editJson = JSON.stringify(formAContenido(this.editForm), null, 2)
      this.editJsonError = ''
    },

    aplicarJsonAlForm() {
      this.editJsonError = ''
      try {
        const contenido = JSON.parse(this.editJson)
        this.editForm = contenidoAForm({
          ...this.editItem,
          ...this.editForm,
          contenido,
          tema: contenido.tema || this.editForm.tema,
        })
      } catch (e) {
        this.editJsonError = 'JSON inválido'
      }
    },

    async guardarEdicion() {
      this.editJsonError = ''
      const contenido = formAContenido(this.editForm)
      this.guardando = true
      try {
        await editarGuion({
          id: this.editForm.id,
          contenido,
          tema: this.editForm.tema,
          explicacion: this.editForm.explicacion,
          orden: this.editForm.orden,
        })
        this.dialogEditar = false
        await this.cargarLista()
        this.validarSuccess('Guion actualizado')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.guardando = false
      }
    },

    async aprobarDudaItem(item) {
      this.loadingDudas = true
      try {
        await aprobarDuda(item.id)
        await this.cargarDudas()
        this.validarSuccess('Duda publicada')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loadingDudas = false
      }
    },

    async rechazarDudaItem(item) {
      this.loadingDudas = true
      try {
        await rechazarDuda(item.id)
        await this.cargarDudas()
        this.validarSuccess('Duda rechazada')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.loadingDudas = false
      }
    },

    abrirEditarDuda(item) {
      this.editDuda = item
      this.editDudaForm = {
        pregunta_o_duda: item.pregunta_o_duda || '',
        respuesta: item.respuesta || '',
      }
      this.dialogEditarDuda = true
    },

    async guardarEdicionDuda() {
      this.guardando = true
      try {
        await editarDuda({
          id: this.editDuda.id,
          pregunta_o_duda: this.editDudaForm.pregunta_o_duda,
          respuesta: this.editDudaForm.respuesta,
        })
        this.dialogEditarDuda = false
        await this.cargarDudas()
        this.validarSuccess('Duda actualizada')
      } catch (error) {
        this.validarError(this.errorMsg(error))
      } finally {
        this.guardando = false
      }
    },
  },
}
</script>

<style scoped>
.guiones-rev {
  background: #f4f7fa;
  min-height: 100%;
}

.edit-turno {
  background: #f4f7fa;
  border: 1px solid #dce6ee;
  border-radius: 8px;
}

.revision-chat {
  max-height: 480px;
  overflow-y: auto;
  padding: 8px;
  background: #f4f7fa;
  border-radius: 8px;
}

.revision-chat__fila {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.revision-chat__fila--alumno {
  justify-content: flex-end;
}

.revision-chat__burbuja {
  max-width: 78%;
  padding: 10px 12px;
  background: white;
  border: 1px solid #dce6ee;
  border-radius: 12px;
}

.revision-chat__fila--alumno .revision-chat__burbuja {
  background: #e3f2fd;
}

.revision-chat__evaluacion {
  padding: 8px;
  background: rgba(255, 255, 255, 0.75);
  border-left: 3px solid #006093;
  border-radius: 4px;
  font-size: 12px;
}

.revision-chat__audio {
  width: 100%;
  max-width: 340px;
}

.guiones-edit-card__title {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  border-bottom: 1px solid #e4ebf0;
  white-space: normal;
  word-break: break-word;
  line-height: 1.35;
  padding-top: 16px;
  padding-bottom: 12px;
}

.guiones-edit-card__title-text {
  max-width: 100%;
}

.guiones-edit-card__body {
  max-height: min(70vh, 640px);
  overflow-y: auto;
}

.mono-json textarea {
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
}
</style>
